import Link from "components/atoms/Link";
import Text from "components/atoms/Text";
import Carousel from "components/molecules/Carousel";
import CarouselItem from "components/molecules/Carousel/CarouselItem";
import { BASE_URL } from "constants/env";
import useWindowSize from "hooks/useWindowSize";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { joinClassnames, mapClassnames } from "utils/map-modifier";

import Modal from "components/organisms/Modal";
import ModalBody from "components/organisms/Modal/Body";
import ModalHeader from "components/organisms/Modal/Header";
import imgSuccess from "images/common/success.png";
import { SwiperOptions } from "swiper";
import Heading from "components/atoms/Heading";

interface SlideCrossSellProps {
  crossSell?: CrossSellProductData[];
  isDetail?: boolean;
  view?: boolean;
  disabled?: boolean;
  addCodePromotion?: boolean;
  onNotifyHasPromotion?: () => void;
  onHandleAdd?: (id: CrossSellProductData) => void;
  onHandleRemove?: (id: CrossSellProductData) => void;
}

interface ItemSlideCrossSellProps extends SlideCrossSellProps {
  itemCrossSell: CrossSellProductData;
  index: number;
  onNotifyHasPromotion?: () => void;
  onHandleChooseProduct: (item: CrossSellProductData, isChecked?: boolean) => void;
}

const ItemSlideCrossSell: React.FC<ItemSlideCrossSellProps> = ({
  view,
  index,
  itemCrossSell,
  disabled,
  isDetail,
  addCodePromotion,
  onNotifyHasPromotion,
  onHandleChooseProduct
}) => {
  const refImage = useRef<any>(null);

  const onHandleAnimationToCart = (item: CrossSellProductData, isChecked?: boolean) => {
    // if (isChecked) {
    //   const cartElement = document.getElementById('shopping-cart');
    //   const imageElement = refImage.current;
    //   if (cartElement && imageElement) {
    //     const clonedImage = imageElement.cloneNode(true) as HTMLElement;
    //     const wrapImageRect = imageElement.getBoundingClientRect();
    //     const cartRect = cartElement.getBoundingClientRect();

    //     clonedImage.style.position = 'fixed';
    //     clonedImage.style.top = `${wrapImageRect.top}px`;
    //     clonedImage.style.left = `${wrapImageRect.left}px`;
    //     clonedImage.classList.add('o-crossSell_flying');

    //     document.body.appendChild(clonedImage);

    //     // Trigger reflow để transition hoạt động
    //     requestAnimationFrame(() => {
    //       clonedImage.style.top = `${cartRect.top}px`;
    //       clonedImage.style.left = `${cartRect.left}px`;
    //     });

    //     // Remove sau khi animation kết thúc
    //     setTimeout(() => {
    //       clonedImage.remove();
    //     }, 800);
    //   }
    // }
    onHandleChooseProduct(item, isChecked);
  };

  const originalPrice = itemCrossSell?.crossSellProduct?.price ? window.formatMoney(Math.round(Number(itemCrossSell?.crossSellProduct?.price) / 1000) * 1000) : '';
  const discountPrice = itemCrossSell?.crossSellProduct?.price ? window.formatMoney(Math.round(Number(itemCrossSell?.priceDiscount) / 1000) * 1000) : '';
  const savedPrice = window.formatMoney((Math.round(Number(itemCrossSell?.crossSellProduct?.price) / 1000) * 1000) - (Math.round(Number(itemCrossSell?.priceDiscount) / 1000) * 1000));

  return (
    <div className="o-crossSell_products_card">
      <div className="o-crossSell_products_sub">
        {
          itemCrossSell?.value && (
            <div className="o-crossSell_products_sub_item_discount">
              Giảm giá
              {/* {window.formatMoney(Math.round(Number(itemCrossSell?.value) / 1000) * 1000)} */}
            </div>
          )
        }
        <div className="o-crossSell_products_sub_item">
          <div className="o-crossSell_products_sub_item-left">
            <div
              ref={refImage}
              className={joinClassnames("a-image", 'o-crossSell_products_sub_item_image')}
            >
              {!!((isDetail || !view) ? `/san-pham/${itemCrossSell?.crossSellProduct?.productTranslations?.[0]?.slug}` : '') ? (
                <Link href={(isDetail || !view) ? `/san-pham/${itemCrossSell?.crossSellProduct?.productTranslations?.[0]?.slug}` : ''}>
                  <img
                    className="a-image_img"
                    alt={itemCrossSell?.crossSellProduct?.productTranslations?.[0]?.name || `Cart Image ${itemCrossSell?.crossSellProduct?.id}`}
                    src={`${BASE_URL}${itemCrossSell?.crossSellProduct?.thumbnail
                      ? itemCrossSell?.crossSellProduct?.thumbnail
                      : ''
                      }`}
                    width="100%"
                    height="auto"
                  />
                </Link>
              ) : (
                <img
                  className="a-image_img"
                  alt={itemCrossSell?.crossSellProduct?.productTranslations?.[0]?.name || `Cart Image ${itemCrossSell?.crossSellProduct?.id}`}
                  src={`${BASE_URL}${itemCrossSell?.crossSellProduct?.thumbnail
                    ? itemCrossSell?.crossSellProduct?.thumbnail
                    : ''
                    }`}
                  width="100%"
                  height="auto"
                />
              )}
            </div>

            <Text className="o-crossSell_products_sub_item_name">{itemCrossSell?.crossSellProduct?.productTranslations?.[0]?.name}</Text>
          </div>

          <div className="o-crossSell_products_sub_item_price">
            {
              !view && (
                <div
                  role="button"
                  className={`o-crossSell_products_sub_item_checkbox ${disabled || addCodePromotion ? 'o-crossSell_products_sub_item_checkbox-disabled' : ''}`}
                  onClick={() => {
                    if (addCodePromotion && onNotifyHasPromotion) {
                      onNotifyHasPromotion();
                      return;
                    }
                    if (disabled) return;
                    onHandleAnimationToCart(itemCrossSell, !itemCrossSell?.checked);
                  }}
                >
                  Thêm
                </div>
              )
            }
            <span className="o-crossSell_products_sub_item_price-original">
              {originalPrice}
            </span>
            <span className="o-crossSell_products_sub_item_price-discount">
              {discountPrice}
            </span>
            <span className="o-crossSell_products_sub_item_price-detail">
              {savedPrice ? `Tiết kiệm: ${savedPrice}` : ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
};

const SlideCrossSell: React.FC<SlideCrossSellProps> = ({
  crossSell,
  view,
  isDetail,
  disabled,
  addCodePromotion,
  onHandleAdd,
  onHandleRemove
}) => {
  const { width } = useWindowSize()
  const [isShow, setShow] = useState(false);
  const [isShowHasPromotion, setShowHasPromotion] = useState(false);
  const [data, setData] = useState<CrossSellProductData[]>([]);

  const onHandleChooseProduct = (item: CrossSellProductData, isChecked?: boolean) => {
    const productIdCrossSell = item.crossSellProduct?.id;
    setData((prev) => prev.map((i) => ({
      ...i,
      checked: i.crossSellProduct?.id === productIdCrossSell ? isChecked : i.checked,
    })));

    if (isChecked && onHandleAdd) {
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 2000);
      onHandleAdd(item);
    } else if (onHandleRemove) {
      onHandleRemove(item);
    }
  };

  const breakpoints = useMemo(() => {
    if (isDetail) {
      return {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 1.5,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1366: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
      } as {
        [width: number]: SwiperOptions;
        [ratio: string]: SwiperOptions;
      };
    }
    return {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 8,
      },
      576: {
        slidesPerView: 1.5,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
        // loopFillGroupWithBlank: true,
      },
      1024: {
        slidesPerView: 2.5,
        // loopFillGroupWithBlank: true,
        spaceBetween: 20,
      },
    } as {
      [width: number]: SwiperOptions;
      [ratio: string]: SwiperOptions;
    };
  }, []);

  const navigateSlide = useMemo(() => {
    if (crossSell && width > 0) {
      if (isDetail) {
        if (width >= 1200 && crossSell?.length > 1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (width >= 1200 && crossSell?.length > 2) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }, [crossSell, width]);

  useEffect(() => {
    if (crossSell) {
      setData(crossSell);
    }
  }, [crossSell]);

  return (
    <div className="o-slideCrossSell">
      <Carousel
        rebuildOnUpdate={!!width}
        slidesPerView="auto"
        customParams={{
          navigation: navigateSlide,
          pagination: !!(width <= 1200),
          updateOnWindowResize: !!width,
          breakpoints: breakpoints
        }}
      >
        {
          data?.map((item, index) => (
            <SwiperSlide key={item.crossSellProduct?.id}>
              <CarouselItem>
                <ItemSlideCrossSell
                  index={index}
                  crossSell={crossSell}
                  disabled={disabled}
                  isDetail={isDetail}
                  itemCrossSell={item}
                  view={view}
                  onHandleChooseProduct={onHandleChooseProduct}
                  onNotifyHasPromotion={() => setShowHasPromotion(true)}
                  addCodePromotion={addCodePromotion}
                />
              </CarouselItem>
            </SwiperSlide>
          ))
        }
      </Carousel>
      <Modal isOpen={isShow} modifiers="transparent">
        <div className="o-slideCrossSell_toast">
          <img src={imgSuccess} alt="logo success" />
          Sản phẩm đã được thêm
          <br />
          vào giỏ hàng
        </div>
      </Modal>
      <Modal radius isOpen={isShowHasPromotion}>
        <ModalHeader
          onCloseRequest={() => setShowHasPromotion(false)}
          noPaddingTop
        >
          <Heading modifiers={["center", "no-margin-bottom"]} type="h3">
            Thông báo
          </Heading>
        </ModalHeader>
        <ModalBody>
          <Text modifiers={['center']}>
            Chương trình mua kèm tặng thêm không áp dụng chung với mã voucher.
          </Text>
        </ModalBody>
      </Modal>
    </div >
  );
};

export default SlideCrossSell;
